import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home.component';
import { GeneralLedgerComponent } from './general-ledger/general-ledger.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    children: [
      { path: '', component: DashboardComponent, pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'disbursement', loadChildren: () => import('./disbursement/disbursement.module').then(v => v.DisbursementModule) },
      { path: 'account', loadChildren: () => import('./account-management/account-management.module').then(v => v.AccountManagementModule) },
      { path: 'account-payabale', loadChildren: () => import('./account-payable/account-payable.module').then(v => v.AccountPayableModule) },
      { path: 'account-receivable', loadChildren: () => import('./account-receivable/account-receivable.module').then(v => v.AccountReceivableModule) },
      { path: 'manage-clients', loadChildren: () => import('./manage-clients/manage-clients.module').then(v => v.ManageClientsModule) },
      { path: 'general-ledger', loadChildren: () => import('./general-ledger/general-ledger.module').then(v => v.GeneralLedgerModule) },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
